export default __webpack_public_path__ + "static/media/traffic-thumb.ff10c02c.png";